<script lang="ts">
    import { servers, RefreshServers } from "@frontend/serverlist";
    import { type GameServerDTO } from "../walletapi";
    import { push } from "svelte-spa-router";
    import Modal from "@frontend/Components/Modal.svelte";
    import AddGameServer from "@frontend/Components/AddGameServer.svelte";
    import EditGameServer from "@frontend/Components/EditGameServer.svelte";
    import { onMount } from "svelte";
    import { translate, currentLanguage } from "../Translator";
    import { me } from "@frontend/user";
    import Pagination from "@frontend/Components/Pagination.svelte";


    let searchInput: string = "";
    let searchServers: GameServerDTO[] = [];
    let currentPage = 1;
    const pageSize = 20;
    $: visibleServers = searchServers.slice((currentPage - 1) * pageSize, currentPage * pageSize);
    
    onMount(async () => {
        // Verificar autenticación primero
        if (!$me) {
            push("/user/Login");
            return;
        }

        await RefreshServers();
    });

    $: {
        currentPage = 1;
        if (searchInput === '') {
            searchServers = $servers;
        } else {
            let searchInputNormalized = searchInput.toLowerCase();
            searchServers = $servers.filter((server) =>
                server.Id?.toString().toLowerCase()?.includes(searchInputNormalized) ||
                server.Label?.toLowerCase()?.includes(searchInputNormalized) ||
                server.User?.toLowerCase()?.includes(searchInputNormalized)
            );
        }
    }

    type EditAction = {
        action: "edit",
        serverid: number;
    };

    type AddAction = {
        action: "add"
    };

    type RouteParams = EditAction | AddAction | undefined;
    
    export let params: RouteParams = undefined;

    function dismiss() {
        push("/GameServerList");
    }

    let selectedServer: GameServerDTO | undefined = undefined;
    $: if (params) {
        if (params.action == "edit") {
            let selectedServerId = params.serverid;
            selectedServer = $servers.find(s => s.Id == selectedServerId);
        }
    }
</script>

{#if params?.action == "add"}
    <Modal dismiss={dismiss}>
        <AddGameServer dismiss={dismiss} />
    </Modal>
{/if}

{#if params?.action == "edit"}
    <Modal dismiss={dismiss}>
        {#if !selectedServer}
            <div class="ui negative message">
                <div class="header">No such server</div>
            </div>
        {:else}
            <EditGameServer server={selectedServer} dismiss={dismiss} />
        {/if}
    </Modal>
{/if}

<h1 class="ui centered dividing header">{$translate('Game Servers')}</h1>

<a href="#/GameServerList/add" class="ui green button">
    <i class="plus icon"></i>
    {$translate('Add Server')}
</a>

<div class="ui icon input">
    <input 
        type="text" 
        placeholder="Search servers..." 
        bind:value={searchInput}
    >
    <i class="search icon"></i>
</div>

<table class="ui celled table">
    <thead>
        <tr>
            <th class="right aligned" style="width: 0px">ID</th>
            <th>{$translate('Label')}</th>
            <th>{$translate('Username')}</th>
            <th>{$translate('Password')}</th>
            <th>{$translate('Endpoint')}</th>
            <th>{$translate('Options')}</th>
        </tr>
    </thead>
    <tbody>
        {#each visibleServers ?? [] as server}
            <tr>
                <td class="right aligned" style="width: 0px">{server.Id}</td>
                <td>{server.Label ?? ""}</td>
                <td>{server.User ?? ""}</td>
                <td>{server.Password ?? ""}</td>
                <td>{server.Endpoint ?? ""}</td>
                <td class="center aligned">
                    <a href="#/GameServerList/edit/{server.Id}" class="ui icon primary button">
                        <i class="edit icon"></i>
                    </a>
                </td>
            </tr>
        {/each}
    </tbody>
</table>
<Pagination page={currentPage} totalItems={searchServers.length} {pageSize} on:change={(event) => currentPage = event.detail} />

<style>
    .center {
        text-align: center;
    }
</style>
